import { render, staticRenderFns } from "./StartFooter.vue?vue&type=template&id=77849fea&scoped=true"
import script from "./StartFooter.vue?vue&type=script&lang=js"
export * from "./StartFooter.vue?vue&type=script&lang=js"
import style0 from "./StartFooter.vue?vue&type=style&index=0&id=77849fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77849fea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VList,VListItem})
